import React from 'react';
import {
  NameDisplay,
  NameEditor,
} from 'components/text-editor/components/controls/components/name-text-snippet-editor/components/name-editor';

export interface NameTextSnippetEditorProps {
  name?: string;
  isNameDisplayVisible: boolean;
  isNameEditorVisible?: boolean;
  saveTextSnippet: (name?: string) => void;
  deleteTextSnippet: () => void;
  showNameEditor: Function;
  hideNameEditor: Function;
}

const defaultProps = {};

function NameTextSnippetEditor({
  name,
  isNameDisplayVisible,
  isNameEditorVisible,
  showNameEditor,
  hideNameEditor,
  saveTextSnippet,
  deleteTextSnippet,
}: NameTextSnippetEditorProps) {
  return (
    <>
      {isNameDisplayVisible && (
        <NameDisplay name={name} showNameEditor={showNameEditor} />
      )}
      {isNameEditorVisible && (
        <NameEditor
          name={name}
          hideNameEditor={hideNameEditor}
          onSave={saveTextSnippet}
          onDelete={deleteTextSnippet}
        />
      )}
    </>
  );
}

NameTextSnippetEditor.defaultProps = defaultProps;

export default NameTextSnippetEditor;
